import { WbText } from '@workbench/react';

interface HeadingProps {
    header: string;
    size?: 'l' | 'm' | 's';
    mandatory?: boolean;
    readOnly?: boolean;
    labelStrong?: boolean;
}

function Heading(props: Readonly<HeadingProps>) {
    const showMandatoryStar = () => {
        //the star is only visable if its mandatory and not readonly
        if (props.readOnly !== undefined && props.readOnly) {
            return false;
        }
        if (props.mandatory !== undefined && props.mandatory) {
            return true;
        }

        return false;
    };

    return (
        <WbText size={props.size ?? 'm'} strong={props.labelStrong === false ? undefined : true}>
            {props.header}
            {showMandatoryStar() && '*'}
        </WbText>
    );
}

export default Heading;
